export default "__VITE_ASSET__C420ctFH__"